/*
 * <omosa-back-in-stock>: "Me prévenir du retour en stock" (snippets/product-back-in-stock.liquid).
 * Sends the email and the sold-out size to Klaviyo (client API, public key only, made for the
 * browser); Klaviyo's back-in-stock flow emails the visitor when the size is restocked.
 * https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
 * The form is a plain form (not a Shopify contact form): only this script sends it.
 */
const KLAVIYO_REVISION = '2026-10-15';

class OmosaBackInStock extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.form.querySelector('input[type="email"]');
    this.button = this.form.querySelector('button[type="submit"]');
    this.message = this.querySelector('[data-message]');
    // Capture phase: no other script ever sees this submit (it once was re-sent to /contact)
    this.form.addEventListener('submit', (event) => this.submit(event), true);
  }

  async submit(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!this.input.checkValidity()) {
      this.show(this.dataset.invalid, true); // written error, tied to the field (not only the browser's bubble)
      this.input.focus();
      return;
    }
    this.button.disabled = true;
    try {
      const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${encodeURIComponent(this.dataset.publicKey)}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(this.payload(this.input.value.trim())),
      });
      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
      this.form.hidden = true;
      this.show(this.dataset.success, false);
    } catch {
      this.show(this.dataset.error, true);
    } finally {
      this.button.disabled = false;
    }
  }

  payload(email) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email } } },
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.klaviyoVariant}` } },
        },
      },
    };
  }

  show(text, isError) {
    this.message.textContent = text;
    this.message.classList.toggle('product__notify-message--error', isError);
    if (isError) {
      this.input.setAttribute('aria-invalid', 'true');
      this.input.setAttribute('aria-describedby', this.message.id);
    } else {
      this.input.removeAttribute('aria-invalid');
    }
  }
}

if (!customElements.get('omosa-back-in-stock')) customElements.define('omosa-back-in-stock', OmosaBackInStock);
